import { Color } from 'three';

// The colours and strengths of the sky, sun and ambient light for a given sun height and weather.
// Pure, so the two sky domes (GLSL and node material) and the tests all use the same numbers.

const mix = (a, b, t) => a + (b - a) * t;
const clamp01 = (v) => (v < 0 ? 0 : v > 1 ? 1 : v);

// Sky colours at night, at the horizon-sun moment, and in full day.
export const ZENITH = [new Color('#070b1c'), new Color('#33558f'), new Color('#2f6fc4')];
export const HORIZON = [new Color('#141a2e'), new Color('#f0a070'), new Color('#b9d6ee')];
export const SUN = [new Color('#5d7cb8'), new Color('#ffb070'), new Color('#fff4e0')];
const GREY = new Color('#aab2ba');

function threeWay(set, night, day, out) {
  // night: 1 when the sun is well down; day: 1 when it is well up
  if (night > 0) out.copy(set[1]).lerp(set[0], night);
  else out.copy(set[1]).lerp(set[2], day);
  return out;
}

// alt: the sun's height above the horizon in degrees. weather: { cloud, rain, fog } each 0-1.
// out: { top, horizon, sun, hemi, ground } Colors to fill. Returns the numbers that go with them.
export function skyState(alt, weather, out) {
  const day = clamp01(alt / 14);
  const night = clamp01(-alt / 8);
  const { cloud, rain, fog } = weather;
  const grey = clamp01(cloud * 0.75 + rain * 0.25);
  const tmp = new Color();
  threeWay(ZENITH, night, day, out.top).lerp(tmp.copy(GREY).multiplyScalar(mix(0.12, 0.85, 1 - night)), grey * 0.8);
  threeWay(HORIZON, night, day, out.horizon).lerp(tmp.copy(GREY).multiplyScalar(mix(0.16, 1, 1 - night)), grey * 0.85);
  threeWay(SUN, night, day, out.sun);
  const up = alt > -4; // by night the light comes from the moon, placed opposite the sun
  const direct = up ? mix(0.25, 3.4, day) * (1 - grey * 0.82) : 0.22 * (1 - grey * 0.6);
  const ambient = mix(0.42, 1.7, 1 - night) * mix(1, 0.85, grey);
  out.hemi.copy(out.top).lerp(tmp.set(0xffffff), 0.55);
  out.ground.set(0x8a7a60).multiplyScalar(mix(0.4, 1, 1 - night));
  const haze = clamp01(fog + rain * 0.5 + cloud * 0.15);
  return { day, night, grey, up, direct, ambient, glow: (1 - grey * 0.9) * (1 - night), haze, daylight: 1 - night, moonColor: SUN[0] };
}
